import { render, staticRenderFns } from "./IncompleteNotificationHistoryTable.vue?vue&type=template&id=b392a21c&scoped=true&"
import script from "./IncompleteNotificationHistoryTable.vue?vue&type=script&lang=js&"
export * from "./IncompleteNotificationHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./IncompleteNotificationHistoryTable.vue?vue&type=style&index=0&id=b392a21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b392a21c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
